export const UserType = {
    GENERAL_USER: 1,
    SUPER_USER: 2,
    SME: 3,
    SKILLING_ARCHITECT: 4,
    VIEWER: 5,
    READER: 6,
    LEAD_GEN_TOOL: 7,
    GENERAL_USER_INTERNAL: 8
}